import type React from 'react'

type SpacerSize = 'button' | 'content' | 'section' | 'top' | 'paragraph' | 'articleSection'

interface VerticalSpacerProps {
  size?: SpacerSize
}

const sizeClasses: Record<SpacerSize, string> = {
  button: 'h-8 lg:h-10',
  content: 'h-4 lg:h-6',
  section: 'h-12 lg:h-24',
  top: 'h-10 sm:h-16 lg:h-10', // lg:h-24 to big for most pages
  paragraph: 'h-2 lg:h-3',
  articleSection: 'h-14 lg:h-12'
}

export const VerticalSpacer: React.FC<VerticalSpacerProps> = ({ size = 'button' }) => {
  return <div className={sizeClasses[size]} />
}
